import { render, staticRenderFns } from "./ConvoyInfoPanelFull.vue?vue&type=template&id=19dcb636&scoped=true"
import script from "./ConvoyInfoPanelFull.vue?vue&type=script&lang=js"
export * from "./ConvoyInfoPanelFull.vue?vue&type=script&lang=js"
import style0 from "./ConvoyInfoPanelFull.vue?vue&type=style&index=0&id=19dcb636&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19dcb636",
  null
  
)

export default component.exports